import React, { useState, useEffect } from "react";
import { MSG } from "../constants/toastMessages";
import { apiCallingPost } from '../api/services';
import Logo from "../assets/images/logo.webp"
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';

// Decode the email out of the invite JWT payload so we can prefill it on the login page
// after activation. Best-effort only — never trusted for anything, purely a UX convenience.
function emailFromToken(token) {
    try {
        const payload = token.split('.')[1];
        const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
        return JSON.parse(json).emaild || "";
    } catch (e) {
        return "";
    }
}

// Task #13: admin-invited users land here (from the "set your password" email link) to
// choose their own password and activate the account. Mirrors ResetPassword but hits
// setPassword, which also creates the login identity and marks the email verified.
function SetPassword() {
    const location = useLocation();
    const navigate = useNavigate();
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [token, setToken] = useState("")
    const [isExpired, setIsExpired] = useState(false)
    const [saveFlag, setSaveFlag] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const t = queryParams.get("token");
        setToken(t);
        verifyToken(t);
    }, [location.search]);

    const verifyToken = async (t) => {
        // Reuses verifyResetToken — the invite token is stored in reset_token, so this
        // returns success only while the link is still valid/unused.
        const response = await apiCallingPost("api/authentication/verifyResetToken", { token: t });
        const { data } = response;
        if (data.success !== "1") {
            setIsExpired(true)
        }
    }

    const setNewPassword = async () => {
        if (password === "") {
            toast.error(MSG.passwordRequired);
            return;
        }
        if (password.length < 6) {
            toast.error(MSG.passwordShort);
            return;
        }
        if (confirmPassword === "") {
            toast.error(MSG.confirmPasswordRequired);
            return;
        }
        if (password !== confirmPassword) {
            toast.error(MSG.passwordMismatch);
            return;
        }
        setSaveFlag(true);
        const response = await apiCallingPost("api/authentication/setPassword", { token, password });
        const { data } = response;
        if (data.success === "1") {
            toast.success(data.successMessage || "Your password has been set. You can now sign in.");
            const email = emailFromToken(token);
            setTimeout(() => {
                navigate("/login", { state: { email } });
                setSaveFlag(false);
            }, 2000);
        } else {
            toast.error(data.errorMessage || MSG.couldNotProcess);
            setSaveFlag(false);
        }
    }

    return (
        <div className="modal-admin-wrapper popup-outer-div">
            <div className="p-4">
                <a className='login_logo' href="/">
                    <img src={Logo} alt="Logo" className="img-fluid logo-change" width="120" height="50" />
                </a>
            </div>

            {isExpired === false ?
                <div className="modal-ad-popup modal-md">
                    <div className="modal-innerpopup ">
                        <div className="modal-headdiv d-flex justify-content-between">
                            <h5 className="modal-head">Set your password</h5>
                        </div>
                        <div className="modal-admin-body my-3" style={{ maxHeight: 'calc(100vh - 290px)' }}>
                            <div className="modal-admin-body">
                                <p className="text-muted mb-3" style={{ fontSize: '13px' }}>
                                    Choose a password to activate your account. You'll sign in with it next.
                                </p>
                                <div className="form_div" style={{ position: 'relative' }}>
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        id="password"
                                        placeholder="Password"
                                        aria-label="New password"
                                        autoComplete="new-password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        className="form-register-popup"
                                    />
                                    <span
                                        onClick={() => setShowPassword((s) => !s)}
                                        role="button"
                                        aria-label={showPassword ? 'Hide password' : 'Show password'}
                                        title={showPassword ? 'Hide password' : 'Show password'}
                                        style={{ position: 'absolute', right: 14, top: 'calc(50% - 5.5px)', transform: 'translateY(-50%)', cursor: 'pointer', color: '#666', display: 'flex' }}
                                    >
                                        {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                                    </span>
                                </div>
                                <small className="text-muted d-block mb-2" style={{ fontSize: '12px', marginTop: '-6px' }}>
                                    Use at least 6 characters.
                                </small>
                                <div className="form_div">
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        id="confirmPassword"
                                        placeholder="Confirm Password"
                                        aria-label="Confirm new password"
                                        autoComplete="new-password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        className="form-register-popup"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="tag-popup-footer">
                            <div className="d-flex align-items-center gap-2">
                                <button
                                    type="button"
                                    disabled={saveFlag}
                                    className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                                    onClick={() => setNewPassword()}
                                >
                                    {saveFlag ? "Setting…" : "Set Password"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className="modal-ad-popup modal-md">
                    <div className="modal-innerpopup" style={{ color: 'red' }}>This activation link is invalid or has expired. Please ask an administrator to resend the invitation.</div>
                </div>
            }
        </div >
    );
}
export default SetPassword;
